import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ActionsDeleteRemoveIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M14.25.75C15.492.751 16.499 1.758 16.5 3v.75h6c.414 0 .75.336.75.75s-.336.75-.75.75h-1.56l-1.328 15.937c-.103 1.163-1.074 2.057-2.242 2.063H6.631c-1.168-.006-2.14-.9-2.242-2.064L3.06 5.25H1.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75h6V3C7.501 1.758 8.508.751 9.75.75h4.5zm5.185 4.5H4.565l1.318 15.812c.032.386.36.688.748.688H17.37c.39-.002.713-.3.747-.688L19.435 5.25zM9.75 9c.414 0 .75.336.75.75v7.5c0 .414-.336.75-.75.75S9 17.664 9 17.25v-7.5c0-.414.336-.75.75-.75zm4.5 0c.414 0 .75.336.75.75v7.5c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-7.5c0-.414.336-.75.75-.75zm0-6.75h-4.5c-.414 0-.75.336-.75.75v.75h6V3c0-.414-.336-.75-.75-.75z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ActionsDeleteRemoveIcon = __decorateClass([
  customElement("elm-actions-delete-remove-icon")
], ActionsDeleteRemoveIcon);
export { ActionsDeleteRemoveIcon };
